import { Node, Edge } from 'reactflow';
import { AutomationAction, AutomationTrigger } from '@business/entities/automation';
import { AutomationNodeType } from '@modules/automation/AutomationPage/NodeTypes';

export function getAutomation(nodes: Node<AutomationAction>[], edges: Edge[], until?: string) {
  let currentNode = nodes.find(node => node.id === 'start')!;
  const automation: { trigger: AutomationTrigger; actions: AutomationAction[] } = { trigger: currentNode.data, actions: [] };

  do {
    const edge = edges.find(edge => edge.source === currentNode.id)!;
    currentNode = nodes.find(node => node.id === edge.target)!;
    if (currentNode.id == 'end' || currentNode.id === until) {
      break;
    }
    automation.actions.push(currentNode.data);
  } while (currentNode.type != AutomationNodeType.end);
  return automation;
}

export function getPrevNodes(id: string, nodes: Node<AutomationAction>[], edges: Edge[]) {
  if (id === 'start') {
    return [];
  }

  let currentEdge: Edge | undefined = edges.find(edge => edge.target === id)!;
  const interestedNodes = [];
  while (currentEdge) {
    interestedNodes.push(currentEdge.source);
    currentEdge = edges.find(edge => edge.target === currentEdge!.source);
  }
  const allNodes = interestedNodes.map(nodeId => nodes.find(node => node.id === nodeId)!.data.className);

  return allNodes;
}
